import { getOperatorOptions, getOccurenceOptions } from '../logicHelpers'

const querySource = () => {
  return {
    types: [{ label: 'Parameter Name', value: 'custom' }],
    inputs: [
      {
        $formkit: 'text',
        key: 'query-parameter-input',
        name: 'query',
        placeholder: 'parameter name',
        can: (condition: { $source: string }) => condition.$source === 'query'
      },
      {
        $formkit: 'select',
        key: 'query-occurrence-select',
        name: 'occurrence',
        options: getOccurenceOptions(),
        can: (condition: { $source: string }) => condition.$source === 'query'
      },
      {
        $formkit: 'select',
        key: 'query-operator-select',
        name: 'operator',
        options: getOperatorOptions(),
        can: (condition: { $source: string }) => condition.$source === 'query'
      },
      {
        $formkit: 'text',
        key: 'query-value-input',
        name: 'value',
        can: (condition: { $source: string; operator: string }) =>
          condition.$source === 'query' &&
          condition.operator !== 'is set' &&
          condition.operator !== 'is not set'
      }
    ]
  }
}

export default querySource
